<app-market-place-navigation [solutionId] = "this.dialogField.fieldValues['SolutionId']"></app-market-place-navigation>
